<template>
    <div>
         <!-- main-area -->
         <main class="fix">
                <!-- breadcrumb-area -->
                <section class="breadcrumb__area breadcrumb__bg">
                    <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="breadcrumb__content">
                                    <h2 class="title">Profil Pejabat Struktural</h2>
                                    <nav aria-label="breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a href="javascript:void(0);">Profil</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">Profil Pejabat Struktural</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="breadcrumb__shape">
                        <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                    </div>
                </section>


                <section class="team__area-two">
                <div class="container">
                    <div class="row justify-content-center gutter-24">

                        <div class="col-lg-3 col-md-6 col-sm-8" v-for="(data) in list_data" :key="data.id || data.nip">
                            <div class="team__item-two shine-animate-item">
                                <div class="team__thumb-two shine-animate"
                                     @click="openModal(data)"
                                     data-bs-toggle="modal"
                                     data-bs-target="#pegawaiModal"
                                     style="cursor: pointer;">
                                    <img :src="getFoto(data)" alt="Foto Pegawai" @error="$event.target.src='assets/img/user.png'" />
                                </div>
                                <div class="team__content-two">
                                    <h4 class="title">
                                        <a href="javascript:void(0);"
                                           @click="openModal(data)"
                                           data-bs-toggle="modal"
                                           data-bs-target="#pegawaiModal">
                                            {{ formatNama(data) }}
                                        </a>
                                    </h4>
                                    <span>{{ data.nm_jabatan }}</span>
                                </div>
                            </div>

                        </div>
                        <div class="pagination-wrap mt-40">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination list-wrap">
                                    <li class="page-item" :class="{ disabled: page_first === 1 }">
                                        <a class="page-link" href="#" @click.prevent="btn_prev"><i class="fas fa-angle-double-left"></i></a>
                                    </li>
                                    <li
                                            v-for="page in paginationPages"
                                            :key="page"
                                            :class="{ active: page === page_first, disabled: page === '...'}"
                                            class="page-item"
                                            >
                                            <a
                                                v-if="page !== '...'"
                                                class="page-link"
                                                href="#"
                                                @click.prevent="go_to_page(page)"
                                            >
                                                {{ page }}
                                            </a>
                                            <span v-else class="page-link">...</span>
                                        </li>
                                    <li class="page-item" :class="{ disabled: page_first === page_last }">
                                        <a class="page-link" href="#" @click.prevent="btn_next"><i class="fas fa-angle-double-right"></i></a>
                                    </li>
                                    </ul>
                                </nav>
                            </div>

                    </div>
                </div>
                <div class="about__shape-wrap-four">
                    <img src="assets/img/images/h4_about_shape01.png" alt="">
                    <img src="assets/img/images/h4_about_shape02.png" alt="" data-parallax='{"x" : -80 , "y" : -80 }'>
                </div>
            </section>
                    <!-- about-area-end -->
                <!-- breadcrumb-area-end -->
               
                
            </main>
            <!-- main-area-end -->
    
        <!-- Modal Lihat Foto Pejabat -->
        <div class="modal fade" id="pegawaiModal" tabindex="-1" aria-labelledby="pegawaiModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content shadow-lg">
                    <div class="modal-header text-white">
                        <h5 class="modal-title" id="pegawaiModalLabel">{{ form.nama_lengkap || 'Foto Pejabat' }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
                    </div>
                    <div class="modal-body text-center p-3">
                        <img :src="getFoto(form)" :alt="form.nama_lengkap" class="img-fluid rounded shadow-sm" style="max-height: 75vh; width: auto; object-fit: contain;" @error="$event.target.src='assets/img/user.png'" />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

    <script>
        export default {
            data() {
                return {
                    file_path: this.$store.state.URL_APP_SIMPEG + "uploads/",
                    list_data: [],
                    page_first: 1,
                    page_last: 0,
                    perPage: 12, 
                    cari_value: "",
                    uraian: "",
                    form: {
                        nama_lengkap: '',
                        nm_jabatan: '',
                        file: '',
                    }
                }
            },
            computed: {
                paginationPages() {
                    const pages = [];
                    const total = this.page_last;
                    const current = this.page_first;

                    if (total <= 5) {
                        for (let i = 1; i <= total; i++) {
                            pages.push(i);
                        }
                    } else {
                        if (current <= 3) {
                            pages.push(1, 2, 3, '...', total);
                        } else if (current >= total - 2) {
                            pages.push(1, '...', total - 2, total - 1, total);
                        } else {
                            pages.push(1, '...', current, '...', total);
                        }
                    }

                    return pages;
                }
            },
            methods: {
                formatNama(item) {
                    if (!item) return '';
                    const depan = item.gelar_depan ? item.gelar_depan.trim() + ' ' : '';
                    const belakang = item.gelar_belakang ? ', ' + item.gelar_belakang.trim() : '';
                    return `${depan}${item.nama || ''}${belakang}`;
                },
                getFoto(item) {
                    if (!item || !item.file) {
                        return 'assets/img/user.png';
                    }
                    return this.file_path + item.file;
                },
                openModal(data) {
                    if (!data) return;
                    this.selectData(data);
                },
                selectData(data) {
                    this.form = {
                        nama_lengkap: this.formatNama(data),
                        nm_jabatan: data.nm_jabatan || '',
                        file: data.file || '',
                    };
                },
                getView: function() {
                    fetch(this.$store.state.ADD_URL_PEGAWAI + "view", {
                        method: "POST",
                        headers: {
                            "content-type": "application/json",
                        },
                        body: JSON.stringify({
                            data_ke: this.page_first,
                            cari_value: this.cari_value
                        }),
                    })
                        .then((res) => res.json())
                        .then((res_data) => {
                            this.list_data = res_data.data || [];
                            this.page_last = res_data.jml_data || 1;
                        })
                        .catch((err) => {
                            console.error("Gagal memuat profil pejabat:", err);
                        });
                },

                // ================== PAGINASI ====================
                btn_prev() {
                    if (this.page_first > 1) {
                        this.page_first--;
                        this.getView();
                    }
                },
                btn_next() {
                    if (this.page_first < this.page_last) {
                        this.page_first++;
                        this.getView();
                    }
                },
                go_to_page(page) {
                    this.page_first = page;
                    this.getView(); 
                },
                // ================== PAGINASI ====================
            },
            mounted() {
                this.getView();
            }
        };
    </script>



